import { schema, normalize } from 'normalizr';

const inspection = new schema.Entity(
  'inspections',
  {},
  { idAttribute: 'inspectionFor' },
);

const inspectionListSchema = new schema.Array(inspection);

export default data => ({
  ...normalize(data, inspectionListSchema),
  requiredSteps: data
    .filter(({ completed }) => !completed)
    .map(item => item.inspectionFor),
});



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/normalizers/inspection-normalizer.js